import { SheetDescription, SheetHeader, SheetTitle } from 'components/ui/sheet'
import { formatMoney } from 'utils'

import { type BucketData } from './types'
import { DARK_GREEN_COLOR, DARK_RED_COLOR } from './utils'

export default function BucketViewContent ({ bucket }: { bucket: BucketData }) {
  return (
    <>
      <SheetHeader>
        <SheetTitle>
          {bucket.count} Employee{bucket.count === 1 ? '' : 's'}
        </SheetTitle>
        <SheetDescription>
          {bucket.isSavings
            ? `Saving ${bucket.range} per month`
            : `Paying ${bucket.range.replace('-', '')} more per month`}
        </SheetDescription>
      </SheetHeader>

      <div className='mt-6'>
        <table className='w-full'>
          <thead>
            <tr className='border-b border-gray-200 text-left text-sm text-gray-500'>
              <th className='pb-2 font-medium'>Employee</th>
              <th className='pb-2 font-medium text-right'>Current contribution</th>
              <th className='pb-2 font-medium text-right'>New contribution</th>
              <th className='pb-2 font-medium text-right'>Change</th>
            </tr>
          </thead>
          <tbody>
            {bucket.employees
              .sort((a, b) => a.difference - b.difference)
              .map((data) => (
                <tr
                  key={data.employee.id}
                  className='border-b border-gray-100 last:border-0'
                >
                  <td className='py-3 text-gray-900'>
                    {data.employee.name}
                  </td>
                  <td className='py-3 text-right tabular-nums text-gray-600'>
                    {formatMoney(data.currentCost)}
                  </td>
                  <td className='py-3 text-right tabular-nums text-gray-600'>
                    {formatMoney(data.newCost)}
                  </td>
                  <td className='py-3 text-right tabular-nums'>
                    <span style={{ color: data.difference <= 0 ? DARK_RED_COLOR : DARK_GREEN_COLOR }}>
                      {data.difference <= 0 ? '+' : ''}{formatMoney(-data.difference)}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
